import React from 'react';
import './App.css';
import Header from "./Header";
import Homepage from "./Homepage";
import Copyright from "./Copyright";
import { Box } from '@mui/material'; // Lägg till Box

function App() {
    return (
        <Box
            display="flex"
            flexDirection="column"
            minHeight="100vh"
        >
            <Header />
            <Box flexGrow={1}>
                <Homepage />
            </Box>
            <Copyright />
        </Box>
    );
}

export default App;
